import { fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { StorageKeys } from "types/enums/StorageKeys"

import { getStorageItem } from "./localStorage"
import { customParamsSerializer } from "./prepareQueryParams"
import { quotesClear } from "./quotesClear"

export const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL_API,
  prepareHeaders: headers => {
    const token = getStorageItem(StorageKeys.Token)

    if (token) {
      headers.set("Authorization", `Bearer ${quotesClear(token)}`)
    }
    return headers
  },
  paramsSerializer: customParamsSerializer,
})
